import React from 'react';
import notify from 'devextreme/ui/notify';
import {Timeline, TimelineEvent} from 'react-event-timeline';
import { timelineServices } from '../../services/timeline.service';
import { Button, SelectBox } from 'devextreme-react';
import Card from 'react-bootstrap/Card';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import{Utilities}from '../../helpers/utilities';
import { childrenServices } from '../../services/children.service';
import { userServices } from '../../services/user.service';
import { weatherServices } from '../../services/weather.service';
import { spireServices } from '../../services/spire.service';
import { twilioServices } from '../../services/twilio.service';
import DateTimeRangeContainer from 'react-advanced-datetimerange-picker';
import { FormControl } from 'react-bootstrap';
import moment from "moment";
import DataGrid, { Column, Paging } from 'devextreme-react/data-grid';
import ReactList from 'react-list';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export class Timelines extends React.Component {
  constructor(props) {
    super(props);
    this.treeView = null;
      this.state = {
          timelines: [],
          userChildren: [],
          selectedChild: '',
          userId: localStorage.getItem('userId'),
          message: '',
          weather: '',
          spireDailyUsage: [],
          twilioMessages: [],
          phoneNumber: localStorage.getItem('phoneNumber')
      };

    this.onClick = this.onClick.bind(this);
    this.onValueChanged = this.onValueChanged.bind(this);
    var search = new URLSearchParams(this.props.location.search);
    var selectedUserId = search.get("id");
    var roleType=localStorage.getItem('roleType');
    if(selectedUserId!=null){
      this.setState({userId:selectedUserId});
      userServices.getById(selectedUserId).then(
        user=>{
          userServices.getRoleByName(user.roles[0]).then(
            role=>{
              roleType= role.roleType;
              if(roleType===2 || roleType===3 ||roleType===4){//parent, therapist, caregiver
                childrenServices.getByUserId(selectedUserId).then(
                  data=>{
                    if(data.length>0){
                      this.setState({userChildren:data});
                    }
                  },
                  error=>{
                    notify({position:'top right', message:"Failed: "+ error, type:'error',maxWidth:200, closeOnOutsideClick:false, closeOnClick:true, displayTime:6000});
                  }
                );
              }
              else if(roleType===1){//admin
                childrenServices.getAll().then(
                  data=>{
                    if(data.length>0){
                        this.setState({ userChildren:data});
                    }
                  },
                  error=>{
                    notify({position:'top right', message:"Failed: "+ error, type:'error',maxWidth:200, closeOnOutsideClick:false, closeOnClick:true, displayTime:6000});
                  }
                );
              }
            },
            error=>{
              notify({position:'top right', message:"Failed: "+ error, type:'error',maxWidth:200, closeOnOutsideClick:false, closeOnClick:true, displayTime:6000});
            }
          );
        },
        error=>{
          notify({position:'top right', message:"Failed: "+ error, type:'error',maxWidth:200, closeOnOutsideClick:false, closeOnClick:true, displayTime:6000});
        }
      );
    }
    else{
      if(roleType==='2' || roleType==='3' ||roleType==='4'){//parent, therapis, caregiver
        childrenServices.getByUserId(this.state.userId).then(
          data=>{
                if (data.length > 0) {
                data.push({ 'firstName': 'All My Messages', 'lastName': '', 'childrenId': 'All' });
                    this.setState({ userChildren: data });
            }
          },
          error=>{
            notify({position:'top right', message:"Failed: "+ error, type:'error',maxWidth:200, closeOnOutsideClick:false, closeOnClick:true, displayTime:6000});
            }
        );
      }
      else if(roleType==='1'){//admin
        childrenServices.getAll().then(
          data=>{
            if(data.length>0){
                this.setState({ userChildren:data});
            }
          },
          error=>{
            notify({position:'top right', message:"Failed: "+ error, type:'error',maxWidth:200, closeOnOutsideClick:false, closeOnClick:true, displayTime:6000});
          }
        );
        }
    }


    let now = new Date();
    let end = moment(moment(new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0))).add(1, "days");
    let start = moment(end).subtract(30, "days");

    this.state = {
        start : start,
        end : end
    }

      this.applyCallback = this.applyCallback.bind(this);
  }
  
  applyCallback(startDate, endDate){
    this.setState({
        start: startDate,
        end : endDate
      })
    }

  createTimeline(items){
    let item = [];
    let timeline=[];
    if(items){
      for (let i = 0; i < items.length ; i++) {
        if(items[i].dataType==='Video'){
          item.push(
            <TimelineEvent 
              key={i}   
              title=""
              titleStyle={{fontWeight:'bold'}}
              createdAt={Utilities.printShortDate(items[i].createdOn)}
              icon={<i className="material-icons md-18">videocam</i>} 
              iconColor="#6fba1c"
            >
              <video width="400" controls>
                <source src={items[i].data} type="video/mp4"></source>
                Your browser does not support HTML5 video.
              </video>
            </TimelineEvent>
          );
        }
        else if(items[i].dataType==='Image'){
          item.push(
            <TimelineEvent 
              key={i} 
              title="" 
              titleStyle={{fontWeight:'bold'}}
              createdAt={Utilities.printShortDate(items[i].createdOn)}
              icon={<i className="material-icons md-18">camera_alt</i>} 
              iconColor="#FF8000"
            >
              <img src={items[i].data} alt='' width="400"></img>
            </TimelineEvent>
          );
        }
        else if(items[i].dataType==='Text'){
          item.push(
            <TimelineEvent
              key={i} 
              title="" 
              titleStyle={{fontWeight:'bold'}}
              createdAt={Utilities.printShortDate(items[i].createdOn)}
              icon={<i className="material-icons md-18">textsms</i>} 
              iconColor="#03a9f4"
            >
              {items[i].data}
            </TimelineEvent>
          );
        }
      }    
      timeline.push(<Timeline lineColor="#ddd" style={{fontSize:'16px'}}>{item}</Timeline>);
    }
    return timeline;
  }

  onClick(e) {
    this.setState({message:''});
      if (this.state.selectedChild) {

      twilioServices.getByChildId(this.state.selectedChild).then(
            data => {
                if (data.length > 0) {
                    this.setState({ twilioMessages: data });
                }
            },
            error => {
                notify({ position: 'top right', message: "Failed: " + error, type: 'error', maxWidth: 200, closeOnOutsideClick: false, closeOnClick: true, displayTime: 6000 });
            }
        );

    }
    else{
      this.setState({message:'Please choose children.'});
      }
      
  }

    renderTimelineItem = (index, key) => {
        var date = new Date(this.state.twilioMessages[index].timeSmsReceived);
        date.setHours(date.getHours() - (date.getTimezoneOffset() / 60));
        date = date.toString().substring(0, date.toString().indexOf('GMT'));
        
        return (<Card border="primary" style={{ width: '100%', marginBottom: '10px' }}>
            <Card.Header>{date}</Card.Header>
            <Card.Body>
                {this.state.twilioMessages[index].mediaContentType === 'image/jpeg' &&
                    <Card.Img variant="top" src={this.state.twilioMessages[index].azureBlobURl} />
                }
                <Card.Text>
                    {this.state.twilioMessages[index].body}
                </Card.Text>
            </Card.Body>
        </Card>);
    }

  onValueChanged(e) {
    this.setState({selectedChild: e.value});
    // Get weather for the seleted child
    childrenServices.getById(e.value).then(
      data=>{
        if(data){
          weatherServices.getWeatherInfo(data.zip).then(
            result=>{
              if(result && result.main!=null){
                this.setState({weather: "City:" + result.name + " | Temperature: "+ result.main.temp + " | Max: " + result.main.temp_max + " | Min: "+result.main.temp_min});
              }
            },
            error=>{
              notify({position:'top right', message:"Failed: "+ error, type:'error',maxWidth:200, closeOnOutsideClick:false, closeOnClick:true, displayTime:6000});
            }
          );
        }
      },
      error=>{
        notify({position:'top right', message:"Failed: "+ error, type:'error',maxWidth:200, closeOnOutsideClick:false, closeOnClick:true, displayTime:6000});
      }
    );
  }

  render() {
      const { timelines, userChildren, spireDailyUsage, twilioMessages } = this.state;

      return (
          <div>
              <div style={{ display: "inline-block" }}>
                  <div style={{ float: "left", paddingRight: "5px"}}>Child:</div>
                  <div style={{ float: "left", paddingRight: "5px" }}>
                      <SelectBox width={200} dataSource={userChildren}
                              displayExpr={
                                  function (item) {
                                      if (item)
                                          return item.firstName + ' ' + item.lastName;
                                  }
                              }
                              valueExpr={'childrenId'}
                              placeholder={'Choose children'}
                              onValueChanged={this.onValueChanged}
                          //defaultValue={'childrenId'} 
                          />
                      </div>
                  <div style={{ float: "left" }}>
                          <Button
                              key='btnView'
                              width={120}
                              height={30}
                              text='View Timeline'
                              type='default'
                              stylingMode='contained'
                              onClick={this.onClick}
                          />
                      </div>
              </div>
              <div className="timeline">
                  <h4>Timeline</h4>
                  <div style={{ overflow: 'visible', maxHeight: (window.innerHeight - 220) }}>
                      <ReactList
                          itemRenderer={this.renderTimelineItem}
                          length={typeof (this.state.twilioMessages) !== 'undefined' ? twilioMessages.length : 0}
                          type='variable'
                      />
                  </div>
              </div>
          </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Pages/Timelines.js